export default __webpack_public_path__ + "static/pexels-mikhail-nilov-7988238-574ffeebcfa57d1c2f97634b6d38b692.jpg";